export default class globalNavi{
    constructor(param){

        /* 必要なDOM */
        this.pager = document.getElementById('c-pager');
        this.pagerList = document.querySelectorAll('#c-pager>*');
        this.pageTop = document.getElementById('c-pagetop');
        this.pageTopSP = document.getElementById('c-pagetop-footer');

        this.section = document.querySelectorAll('.l-section');
        this.secNum = this.section.length;
        this.position = [];

        /* ステータス */
        this.status = {
            now : "close",
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp",
        }

        this.param = param;

        TweenMax.set(this.pager,{
            x:-100,
        });
        TweenMax.set(this.pageTop,{
            scale:0.8,
        });

    }
    init() {

        //set
        TweenMax.set(this.pager ,{
            opacity:1,
            ease: Sine.easeIn,
        });
        TweenMax.to(this.pager, 0.5 ,{
            delay:4,
            x:0,
            ease: Sine.easeIn,
        });

        //event
        for( let i=0; i<this.secNum; i++) {
            this.pagerList[i].onclick = () => {
                TweenMax.to(window, 0.5, {
                    scrollTo : { y: this.position[i], autoKill:false },
                });
            };
        }

        this.pageTop.onclick = () => {
            TweenMax.to(window, 0.5, {
                scrollTo : { y: 0, autoKill:false },
            });
        };
        this.pageTopSP.onclick = () => {
            TweenMax.to(window, 0.5, {
                scrollTo : { y: 0, autoKill:false },
            });
        };

    }

    change(_y){

        for( let i=0; i<this.secNum; i++) {
            if(_y >= this.position[i]){
                TweenMax.set('#c-pager .is-current', {className:"-=is-current"});
                TweenMax.set(this.pagerList[i], {className:"+=is-current"});
            }
        }

        if(_y < 200){
            TweenMax.to(this.pageTop, 0.3 , {
                opacity:0,
                display: 'none',
                scale: 0.8,
                ease: Sine.easeOut
            });
        }else{
            TweenMax.to(this.pageTop, 0.3 , {
                opacity:1,
                display: 'block',
                scale: 1,
                ease: Sine.easeIn
            });
        }

    }

    pagetop(){



    }


    resize(_h){

        this.position = [];
        for( let i=0; i<this.secNum; i++) {
            let $scp = this.section[i];
            this.position[i] = $scp.getBoundingClientRect().top + window.pageYOffset;
        }

    }
}